import {
    STEP_COMPLETED_STATE,
    STEP_DELAYED_STATE,
    STEP_IN_PROGRESS_STATE,
    STEP_NON_BLOCKING_ANOMALY_STATE
} from "../constants";

export default {
    methods: {
        getStateColor({code: state = null}) {
            switch (state) {
                case STEP_COMPLETED_STATE:
                    return "delivered";
                case STEP_IN_PROGRESS_STATE:
                    return "in-progress";
                case STEP_DELAYED_STATE:
                    return "differed";
                case STEP_NON_BLOCKING_ANOMALY_STATE:
                    return "non-blocking-anomaly";
                default:
                    return "blocking-anomaly";
            }
        },
    }
}
